import React,  { useState}  from 'react';

import {MenuComp, MenuResponsive} from './styles'

import { AiOutlineLink } from "react-icons/ai";

import { Link } from 'react-router-dom'

export function Menu() {

  const [responsive, setResponsive] = useState(0);
  
  const open = function(){

    if(responsive === 0){
      setResponsive(1)
    }
    else{
      setResponsive(0)
    }
  };

  return (

    <MenuComp>
      <div className={responsive === 1 ? 'responsive' : ''}>
        <Link to="/admin"><AiOutlineLink /> Home</Link>
        <Link to="/admin/clients"><AiOutlineLink /> Clientes</Link>
        <Link to="/admin/users"><AiOutlineLink /> Usuários</Link>
        <Link to="/admin/groups"><AiOutlineLink /> Grupos</Link>
        <Link to="/admin/vehicles"><AiOutlineLink /> Veículos</Link>
        <Link to="/admin/profiles"><AiOutlineLink /> Visualização</Link>
        <Link to="/admin/device/lots"><AiOutlineLink /> Lote de Equip.</Link>
        <Link to="/admin/devices"><AiOutlineLink /> Equipamentos</Link>
        <Link to="/admin/line/lots"><AiOutlineLink /> Lote de Linhas</Link>
        <Link to="/admin/lines"><AiOutlineLink /> Linhas</Link>
        <Link to="/admin/device/actives"><AiOutlineLink /> Ativação</Link>
        <a className="icon" onClick={open}>
          <MenuResponsive size={30} />
        </a>
      </div>
    </MenuComp>
  )  
}

export default Menu;